class LocalizationForm extends HTMLElement {
  constructor () {
    super()

    this.filter = this.querySelector('.localization-search')
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]',
      ),
      countryListItems: this.querySelectorAll('li'),
      closeButton: this.querySelector('[data-localization-form-el="close"]'),
    }
  }

  connectedCallback () {
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this)),
    )
    this.filter.addEventListener('input', this.onFilterInput.bind(this))
    this.elements.closeButton?.addEventListener('click', this.onCloseButtonClick.bind(this))
  }

  onFilterInput (event) {
    const filterString = event.target.value.toLowerCase().trim()

    document.querySelector('.hidden-during-search').style.display =
      filterString.length ? 'none' : 'block'

    const countries = [...this.elements.countryListItems]

    countries.forEach((countryEl) => {
      const { name } = countryEl.dataset
      if (!name) return

      if (filterString.length && !name.toLowerCase().includes(filterString)) {
        countryEl.style.display = 'none'
      } else {
        countryEl.style.display = 'block'
      }
    })
  }

  onCloseButtonClick (event) {
    event.preventDefault()

    const countryPickerEl = document.getElementById(`country-picker-desktop`)
    const countryPickerDimmerEl = document.getElementById(`country-picker-dimmer-desktop`)

    if (!countryPickerEl || !countryPickerDimmerEl) return

    countryPickerEl.ariaHidden = countryPickerEl.setAttribute('aria-hidden', true)
    countryPickerEl.classList.add('hidden')
    countryPickerDimmerEl.ariaHidden = countryPickerDimmerEl.setAttribute('aria-hidden', true)
    countryPickerDimmerEl.classList.add('hidden')
  }

  onItemClick (event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.elements.input.value = event.currentTarget.dataset.value

    localStorage.setItem(
      'geoipExemptionData',
      JSON.stringify({
        date: Date.now(),
        isoCode: event.currentTarget.dataset.value,
      }),
    )

    if (
      Shopify.shop === 'triangl-america.myshopify.com' &&
      event.currentTarget.dataset.value === 'AU'
    ) {
      localStorage.removeItem('geoipExemptionData')
    }
    if (form) form.submit()
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm)
}
